import tw from 'twin.macro'
import { graphql } from 'gatsby'
import { slugify } from '@/utils/strings'

import Quote, { QuoteProps } from '@/components/ui/quote'
import Image, { ImageProps } from '@/components/ui/image'
import Slider from '../ui/slider/slider'

export const fragment = graphql`
  fragment SectionSlider on ContentfulSectionSlider {
    __typename
    contentful_id
    internalName
    headline
    slides {
      ... on ContentfulComponentQuote {
        ...Quote
      }
      ... on ContentfulComponentImage {
        ...ComponentImage
        image {
          ...Asset
        }
      }
    }
  }
`

export type DynamicSlide = QuoteProps | ImageProps

export type SliderSectionProps = {
  internalName?: string
  slides: any
  headline?: string
}

export default function SliderSection({ internalName, headline, slides }: SliderSectionProps): JSX.Element {
  return (
    <section id={slugify(internalName)} css={tw`!mt-0`}>
      {headline && (
        <div tw="max-w-6xl mx-auto text-indigoBlue md:px-5 mb-12">
          {headline && <h3 tw="text-center font-normal">{headline}</h3>}
          <Slider customCss={tw`md:[--bw-slider-nav-button-distance:2.44rem]`}>
            {slides.map((slide, index) => {
              if (slide.__typename === 'ContentfulComponentQuote') {
                return (
                  <div key={index} tw="mx-4 md:mx-14 mb-14">
                    <Quote {...slide} imageAspectRatio={1} layout="horizontal" />
                  </div>
                )
              }
              if (slide.__typename === 'ContentfulComponentImage') {
                return (
                  <div
                    key={index}
                    css={[
                      tw`mx-14 mb-14 max-w-full h-full flex items-center justify-center`,
                      !slide.zoomable && tw`pointer-events-none`,
                    ]}
                  >
                    <Image {...slide} />
                  </div>
                )
              }
              return null
            })}
          </Slider>
        </div>
      )}
    </section>
  )
}
